export var BulletinRecipientTarget;
(function (BulletinRecipientTarget) {
    BulletinRecipientTarget["AllClosedInvestors"] = "all-closed-investors";
    BulletinRecipientTarget["AllUnclosedInvestors"] = "all-unclosed-investors";
    BulletinRecipientTarget["AllInvestors"] = "all-investors";
    BulletinRecipientTarget["SelectedInvestors"] = "selected-investors";
})(BulletinRecipientTarget || (BulletinRecipientTarget = {}));
export var BulletinDeliveryMethod;
(function (BulletinDeliveryMethod) {
    BulletinDeliveryMethod["Email"] = "email";
    BulletinDeliveryMethod["Portal"] = "portal";
    BulletinDeliveryMethod["EmailAndPortal"] = "email-and-portal";
})(BulletinDeliveryMethod || (BulletinDeliveryMethod = {}));
export var BulletinAttachmentMode;
(function (BulletinAttachmentMode) {
    BulletinAttachmentMode["SendToAll"] = "send-to-all";
    BulletinAttachmentMode["UniquePerInvestor"] = "unique-per-investor";
})(BulletinAttachmentMode || (BulletinAttachmentMode = {}));
//# sourceMappingURL=index.js.map